import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";

import { loadLots } from "../../store/actions/lotAction";
import { loadLocations } from "../../store/actions/locationAction";
import {
  deleteMenage,
  loadMenages,
  saveMenage,
  updateMenage,
} from "../../store/actions/menageAction";
import { loadQuittances } from "../../store/actions/quittanceAction";
import { loadReglements } from "../../store/actions/reglementAction";

import FormScheduler from "../../components/FormScheduler";
import { loadAgents } from "../../store/actions/agentAction";

class Scheduler extends Component {
  componentDidMount() {
    this.props.loadAgents();
    this.props.loadLots();
    this.props.loadLocations();
    this.props.loadMenages();
    this.props.loadQuittances();
    this.props.loadReglements();
  }

  render() {
    const {
      parametre,
      agents,
      lots,
      locations,
      menages,
      quittances,
      reglements,
      typesLots
    } = this.props;    

    return (
      <Spin
        spinning={!agents || !lots || !locations || !menages || !quittances || !reglements}
        size="large"
        tip="Chargement en cours..."
      >
        {agents && lots && locations && menages && quittances && reglements && (
          <FormScheduler
            parametre={parametre}
            agents={agents}
            lots={lots}
            locations={locations}
            menages={menages}
            quittances={quittances}
            reglements={reglements}
            typesLots={typesLots}
            saveMenage={this.props.saveMenage}
            updateMenage={this.props.updateMenage}
            deleteMenage={this.props.deleteMenage}
            addPanesRequete={this.props.addPanesRequete}
          />
        )}
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadAgents: () => dispatch(loadAgents()),
    loadLots: () => dispatch(loadLots()),
    loadLocations: () => dispatch(loadLocations()),
    loadMenages: () => dispatch(loadMenages()),
    loadQuittances: () => dispatch(loadQuittances()),
    loadReglements: () => dispatch(loadReglements()),
    saveMenage: (jsonData) => dispatch(saveMenage(jsonData)),
    updateMenage: (jsonData, id) => dispatch(updateMenage(jsonData, id)),
    deleteMenage: (id) => dispatch(deleteMenage(id)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    agents: state.agents.data,
    parametre: state.parametre.data,
    lots: state.lots.data,
    locations: state.locations.data,
    menages: state.menages.data,
    quittances: state.quittances.data,
    reglements: state.reglements.data,
    typesLots: state.typesLots.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Scheduler);
